<script setup>
import { computed } from 'vue'

/**
 * A plain progress bar: a value read against a maximum, drawn in one colour.
 *
 * It knows nothing about what is being measured, so any page can show "how far along" with it
 * (see components/EventStageProgress.vue for the stages of an event).
 */
const props = defineProps({
  /** How much is done. */
  value: { type: Number, default: 0 },
  /** What being done looks like: the value that fills the bar. */
  max: { type: Number, default: 100 },
  /** Vuetify colour of the filled part. */
  color: { type: String, default: 'primary' },
  /** Thickness of the bar, in pixels. */
  height: { type: Number, default: 6 },
})

const percent = computed(() => {
  if (props.max <= 0) return 0

  return Math.min(100, Math.max(0, (props.value / props.max) * 100))
})
</script>

<template>
  <v-progress-linear
    :model-value="percent"
    :color="color"
    :height="height"
    bg-color="rgba(var(--v-theme-on-surface), 0.12)"
    rounded
    aria-hidden="true"
  />
</template>
